import React, {useContext} from "react";
import {Avatar, Paper, Typography} from "@mui/material";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import moment from "moment";
import {LanguageContext} from "../context/LanguageContext";
import {CompanyEnvironmentContext} from "../context/CompanyEnvironmentContext";

const Footer = () => {
  const languageContext = useContext(LanguageContext);
  const companyEnvironmentContext = useContext(CompanyEnvironmentContext);

  const footerElementList = [
    {title: "dataProtection"},
    {title: "dataProcessingCode"},
    {title: "gtc"},
    {title: "certificates"},
    {title: "impress"},
    {title: "providerInformation"},
    {
      title: "filteringSoftware",
      url: "http://nmhh.hu/cikk/187272/Szuroszoftverek_a_karos_internetes_tartalmak_ellen_gyerekzar",
      target: "&quot;_blank&quot;"
    },
    {title: "coServiceOffers"},
    {title: "premiumServices"},
    {title: "socialResponsibility"},
  ];

  return (
    <Paper square elevation={0} sx={{backgroundColor: "primary.main", zIndex: 1}}>
      <Grid container sx={{padding: "48px"}} columnSpacing={5}>
        <Grid item xs={12} sm={3.5} sx={{textAlign: "center", alignContent: "center", paddingBottom: 2}}>
          <Avatar
            variant="square"
            sx={{width: "100%", height: "45px"}}
            slotProps={{img: {sx: {objectFit: "contain"}}}}
            src={companyEnvironmentContext.logos.fullWhite}
          />
          <Typography style={{paddingLeft: 5}} variant="caption" color="primary.contrastText">
            {`COPYRIGHT© ${moment().year()} ${languageContext.dictionary.footerCopyright}`}
          </Typography>
        </Grid>
        <Grid container item xs={12} sm={8.5} columnSpacing={1} rowSpacing={1.5} sx={{textAlign: "center", alignContent: "center"}}>
          {footerElementList?.map((footerElement, index) => (
            <Grid item xs={12} sm={4} key={`link_${index}`}>
              <Link
                href={footerElement.url || languageContext.dictionary.urls[footerElement.title]}
                target={footerElement?.target || ""}
              >
                <Typography
                  style={{paddingLeft: "12px"}}
                  variant="caption"
                  color="primary.contrastText"
                  key={`typography_${index}`}
                >
                  {languageContext.dictionary.footer[footerElement.title] || footerElement.title}
                </Typography>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Footer;
